module.exports = __webpack_public_path__ + "static/img/bi-business-intelligence.f7724f9a.png";